import { render, staticRenderFns } from "./ScaleQuestion.vue?vue&type=template&id=37d0f9f4&scoped=true&"
import script from "./ScaleQuestion.vue?vue&type=script&lang=js&"
export * from "./ScaleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ScaleQuestion.vue?vue&type=style&index=0&id=37d0f9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0f9f4",
  null
  
)

export default component.exports